import React from "react";
import { Link } from "react-router-dom";

import "./Header.css";

const Header = () => {
    return (
        <nav className="nav">
            <img className="nav-logo-image" src="images/TimerZ-100.png" alt="TimerZ" />
            <div className="nav-logo-text">
                <div className="logo-title">TimerZ</div>
                <div className="logo-subtitle"> Last Timer You'll Ever Need! </div>
            </div>
            <ul className="nav-items">
                <li> <Link to="/home">Home</Link> </li>
                <li> <Link to="/privacy">Privacy</Link> </li>
                <li> <Link to="/contact">Contact</Link> </li>
            </ul>
        </nav>
    );
};

export default Header;
